module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid.0aec4595.svg";